import { createSelector } from '@ngrx/store';
import { State as AppState } from '@app/core/store/reducers';
import { ProgramsState } from '@app/core/store/programs/reducers';

export const featureSelector = (state: AppState): ProgramsState => state.programs;

export const selectProgram = createSelector(
  featureSelector,
  (state: ProgramsState) => state.program,
);

export const selectError = createSelector(
  featureSelector,
  (state: ProgramsState) => state.error,
);
